export default {
  title: 'Olimp Casino',
  shortTitle: 'Olimp',
  preloaderBg: '#1d1d1d',
  preloaderBg2: 'olimp_test_var',
  tokenKey: 'token',
  bgColor: '#1d1d1d',
  themeColor: '#882211',
  tileColor: '#b91d47',
  platformSite: 'olimp.com/casino',
  preloaderIcon: 'img/favicon.svg',
  mainDomain: 'olimp.com',
  useTelegramMiniApp: false,
  usePoker: false,
}
